const MODULE_NAME = 'PASSWORD_NEW';
const PASSWORD_NEW_SUBMIT_STARTED = MODULE_NAME + 'SUBMIT_STARTED';
const PASSWORD_NEW_SUBMIT_COMPLETED = MODULE_NAME + 'SUBMIT_COMPLETED';

export {
  PASSWORD_NEW_SUBMIT_COMPLETED,
  PASSWORD_NEW_SUBMIT_STARTED
};
